/**
 * Created by Rodrigo Quesada on 17/02/17.
 */
import {Routes, Route, ActivatedRoute, ActivatedRouteSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {NavigableNode, NavigableNodeDeps} from './navigable-node.class';
import {RouteConfig} from './sections.service';

export class ScreenConfiguration {
    id: string;
    screensManager?: any;
}

export class Screen extends NavigableNode<Screen, any> {

    TYPE = Screen;
    CHILD_TYPE = undefined as any;

    id: string;

    constructor(navigableNodeDeps: NavigableNodeDeps, route: Route) {
        super(navigableNodeDeps, route, []);

        if (route.data && route.data[RouteConfig.SCREEN]) {
            let screenConfig: ScreenConfiguration = route.data[RouteConfig.SCREEN];
            this.id = screenConfig.id;
            let screensManager = screenConfig.screensManager;
            if (screensManager) {
                screensManager = this._nvnm.injector.get(screensManager);
                this.pathMatches = path => screensManager.pathMatches(path);
            }
        }
    }

    static fromRoutes(navigableNodeDeps: NavigableNodeDeps, routes: Routes): Observable<Screen> {
        return Screen._fromRoutes(navigableNodeDeps, Screen, routes);
    }

    static _fromRoute(navigableNodeDeps: NavigableNodeDeps, screenRoute: Route): Observable<Screen> {
        let screens$: Observable<Screen>;

        if (Screen._isAssociatedRoute(screenRoute)) {
            screens$ = Observable.of(new Screen(navigableNodeDeps, screenRoute));
        }
        else {
            screens$ = Observable.of();
        }

        return screens$;
    }

    static _findAssociatedRoute(route: ActivatedRoute): ActivatedRoute|undefined {
        route = route.firstChild;
        if (!!route && Screen._isAssociatedRoute(route.snapshot)) return route;
    }

    static _isAssociatedRoute(route: Route|ActivatedRouteSnapshot): boolean {
        return route.component !== undefined;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/sections/service/screen.class.ts